import {
  getSetupTemplateQueryOptions,
  getSetupTemplatesByAdAccountQueryOptions,
} from "../../queries/setupTemplates";
import { getAdAccountsQueryOptions } from "../../queries/adAccounts";

// necessary entities are pre-fetched when a user hover a 'edit setupTemplate' link
export const setupTemplateFormLoader = ({ context: { queryClient } }) => {
  queryClient.ensureQueryData(getAdAccountsQueryOptions());
};

// setupTemplates are pre-fetched when a user hover a 'setupTemplates' link within a adAccount
export const setupTemplateListByAdAccountLoader = ({
  params,
  context: { queryClient },
}) => {
  const { adAccountId } = params;
  queryClient.ensureQueryData(
    getSetupTemplatesByAdAccountQueryOptions(adAccountId, queryClient)
  );
};

// setupTemplate is pre-fetched when a user hover a 'view setupTemplate' link
export const setupTemplateViewLoader = ({ params, context: { queryClient } }) => {
  const { setupTemplateId } = params;
  queryClient.ensureQueryData(
    getSetupTemplateQueryOptions(setupTemplateId, queryClient)
  );
};
